import React, { useEffect } from "react";

import GlipAuthGlobal from './services/walletService';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Main from "./components/Main";
import UserWalletConfirmationPage from "./components/UserWalletConfirmation/UserWalletConfirmationPage";
import SwapTokens from "./components/UserWallet/SwapTokens";
import TransferTokens from "./components/UserWallet/TransferTokens";
import NFTDetails from "./components/UserWallet/NFTDetails";
import OffRampPage from "./components/OffRampComponents/OffRampPage";
import RazorpayOffRampPage from "./components/OffRampComponents/RazorpayOffRampPage";
import MudrexOffRampPage from "./components/OffRampComponents/MudrexOffRampPage";
import MudrexOffRampPageMain from "./components/OffRampComponents/MudrexOffRampPageMain";
import RazorpayBuyBtxPage from "./components/UserWallet/RazorpayBuyBtxComponent";
import RoninWalletDashboard from "./components/RoninWallet";

import { ToastContainer, Zoom } from 'react-toastify';
import { init } from '@amplitude/analytics-browser';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { callbackEncryptRequest } from './services/androidCallback';
import { getSetUserId } from './services/backendHelpers';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function App() {

  useEffect(() => {

    // an empty method
    const params = new URLSearchParams(window.location.search);
    const walletType = params.get('walletType');
    if (walletType) {
      localStorage.setItem('gw-wallet-type', walletType);
    }
    (window as any).glipWalletGlobal = GlipAuthGlobal;
    (window as any).callbackEncryptRequest = callbackEncryptRequest;
  }, []);

  useEffect(() => {
    // Option 1, initialize with API_KEY only
    // dont do this if url has ronin
    
    if (!localStorage.getItem('gw-glipggtoken-data')) {
      return;
    }
    init('8b41da3c9f427c0d043baf50c941bd00');
    getSetUserId({});
  });

  // console.log('legend33');
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <I18nextProvider i18n={i18n}>
        <Router>
          <ToastContainer style={{
            marginBottom: 16,
            justifyContent: 'center'
          }} limit={1} transition={Zoom} />
          <Routes>
            <Route path="/wallet-host/" element={<Main />} />
            <Route path="/wallet-host/swap/" element={<SwapTokens />} />
            <Route path="/wallet-host/transfer/" element={<TransferTokens />} />
            <Route path="/wallet-host/wallet-confirmation/"
              element={<UserWalletConfirmationPage />} />
            <Route path="/wallet-host/nft-details/" element={<NFTDetails />} />
            <Route path="/wallet-host/off-ramp/" element={<OffRampPage />} />
            <Route path="/wallet-host/mudrex-off-ramp/" element={<MudrexOffRampPage />} />
            <Route path="/wallet-host/mudrex-off-ramp-main/" element={<MudrexOffRampPageMain />} />
            <Route path="/wallet-host/razorpay-offramp" element={<RazorpayOffRampPage />} />
            <Route path="/wallet-host/razorpay-buy-btx" element={<RazorpayBuyBtxPage />} />
            <Route path="/wallet-host/ronin-wallet" element={<RoninWalletDashboard />} />
          </Routes>
        </Router>
      </I18nextProvider>
    </ThemeProvider>


  );
}

export default App;
